var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-1200"},[_c('div',{staticClass:"content ml-auto mr-auto"},[_c('header',{staticClass:"d-flex justify-content-between align-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('aiAssistancePage.title')))])]),_c('ai-requests-overview',{staticClass:"ai-requests-overview"}),_c('ai-product-requests')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }